import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { slideInOutAnimation } from '@toro/common/shared/animations/slide-in-out.animation';
import { Overlay } from '@toro/common/shared/resources/Overlay';
import { LayerService } from '@toro/common/shared/services/LayerService';
import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { RoutesTable } from '@toro/common/shared/resources/routes-table.model';
import { environment } from '@hub-workspace/apps/logged-home/src/environments/environment';

@AutoUnsubscribe()
@Component({
    selector: 'home-logged-transfer-modal',
    templateUrl: './home-logged-transfer-modal.component.html',
    styleUrls: ['./home-logged-transfer-modal.component.scss'],
    animations: [slideInOutAnimation],
    host: { '[@slideInOutAnimation]': '' },
    encapsulation: ViewEncapsulation.None,
})
export class HomeLoggedTransferModalComponent extends Overlay implements OnDestroy {
    public isNewBrand: boolean = environment.isNewBrand

    constructor(
        public layerService: LayerService,
        public router: Router,
    ) {

        super();

    }

    public redirectToBankData() {
        this.router.navigateByUrl(RoutesTable.hubUrls.routes.MyAccountBankData.uri);
    }

    public ngAfterContentInit() {
        super.ngAfterContentInit();
        sessionStorage.setItem('didShowTransfer', 'true');
    }

    public ngOnDestroy() {
        super.ngOnDestroy();
    }

}
